export default __webpack_public_path__ + "static/media/hedaer_logo.d0f5703c.webp";